module.exports = __webpack_public_path__ + "img/popularize-pic-01.37acb0db.png";